import React, {FC} from 'react';
import {IIconProps} from "../../../types/common";
import {parseStyles} from "../../../utils/parsing";

const PlusIcon: FC<IIconProps> = ({width, height}) => {
    width = width ? width : 20
    height = height ? height : 20

    return (
        <svg fill="none" className="bg-blue-200 rounded-[50%] hover:bg-blue-400" viewBox="0 0 24 24" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
            <path clipRule="evenodd" d="m11 11v-4c0-.55228.4477-1 1-1s1 .44772 1 1v4h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4h-4c-.55228 0-1-.4477-1-1s.44772-1 1-1zm1-9c-5.52285 0-10 4.47715-10 10 0 5.5228 4.47715 10 10 10 5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10zm12 10c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12 0-6.62742 5.37258-12 12-12 6.6274 0 12 5.37258 12 12z" fill="#555555" fillRule="evenodd"/>
        </svg>
    );
}
export default PlusIcon;